export const getBudgetBenchmarkCalculator = state => state.budgetBenchmarkCalculator;
